import {
  ADD_CREATIVE,
  ADD_CREATIVES,
  ADD_DCM_CREATIVES,
  ADD_DIMENSIONS,
  EDIT_CREATIVE,
  REMOVE_CREATIVE,
  SELECT_CREATIVE,
  DESELECT_CREATIVE,
  CLEAR_SELECTED_CREATIVES,
  SET_WEIGHT_DISTRIBUTION,
  SET_ROTATION_TYPE,
  SET_ASSIGNED_PLACEMENTS,
  REORDER_CREATIVES,
  SET_START_DATE,
  SET_END_DATE,
  SET_HARD_CUTOFF,
  SET_CREATIVE_API_ERROR,
  ADD_BACKUP,
  RESET_CREATIVE_STATE,
  SET_DYNAMIC_TARGETING_KEYS
} from "./constants";

import { addCustomLandingPage } from "../dcm/landingPages";

import uuid from "uuid";

const defaultCreative = {
  taxonomy: {
    name: ""
  },
  creativeRole: "PRIMARY",
  file: {
    name: ""
  },
  dimensions: "N/A",
  weight: 0
};

export const addCreative = (creative) => ({
  type: ADD_CREATIVE,
  creative: { ...defaultCreative, ...creative, id: uuid.v4() }
});

export const addCreatives = (creatives) => ({
  type: ADD_CREATIVES,
  creatives: creatives.map((c) => ({
    ...defaultCreative,
    ...c,
    id: c.id ? c.id : uuid.v4()
  }))
});

export const addBackupCreatives = (primaryIds, backupCreative) => ({
  type: ADD_BACKUP,
  primaryIds,
  backupCreative: {
    ...defaultCreative,
    ...backupCreative,
    id: backupCreative.id ? backupCreative.id : uuid.v4(),
    creativeRole: "BACKUP"
  }
});

export const addDcmCreatives = (dcmCreatives) => {
  let creatives = dcmCreatives.map((c) => {
    let cToReturn = {
      ...defaultCreative,
      taxonomy: {
        name: c.name
      },
      file: {
        ...defaultCreative.file,
        size: c.size.width + " x " + c.size.height
      },
      dcmId: c.id,
      dcmCreative: {
        ...c
      },
      id: uuid.v4()
    };

    if (cToReturn.dcmCreative.hasOwnProperty("clickTags")) {
      if (cToReturn.dcmCreative.clickTags[0].clickThroughUrl.landingPageId) {
        cToReturn.taxonomy["urlId"] =
          cToReturn.dcmCreative.clickTags[0].clickThroughUrl.landingPageId;
      } else {
        cToReturn.taxonomy["urlId"] =
          cToReturn.dcmCreative.clickTags[0].clickThroughUrl.customClickThroughUrl;
          //TODO: Find a way to trigger addCustomLandingPAge
      }
    }

    return cToReturn;
  });

  return { type: ADD_DCM_CREATIVES, creatives };
};

export const addDimensions = (id, dimensions, primaryIds) => ({
  type: ADD_DIMENSIONS,
  id,
  dimensions,
  primaryIds
});

export const editCreative = (creative) => ({
  type: EDIT_CREATIVE,
  creative: { ...creative }
});

export const removeCreative = (id) => ({
  type: REMOVE_CREATIVE,
  id
});

export const selectCreative = (id) => ({
  type: SELECT_CREATIVE,
  id
});

export const deselectCreative = (id) => ({
  type: DESELECT_CREATIVE,
  id
});

export const clearSelectedCreatives = () => ({
  type: CLEAR_SELECTED_CREATIVES
});

export const setWeightDistribution = (weightDistribution) => ({
  type: SET_WEIGHT_DISTRIBUTION,
  weightDistribution
});

export const setRotationType = (rotationType) => ({
  type: SET_ROTATION_TYPE,
  rotationType
});

export const setAssignedPlacements = (assignedPlacements) => ({
  type: SET_ASSIGNED_PLACEMENTS,
  assignedPlacements
});

export const reorderCreatives = (id, source, destination) => ({
  type: REORDER_CREATIVES,
  id,
  source,
  destination
});

export const setStartDate = (startDate) => ({
  type: SET_START_DATE,
  startDate
});

export const setEndDate = (endDate, timeSpecified = true) => ({
  type: SET_END_DATE,
  endDate,
  timeSpecified
});

export const setHardCutoff = (hardCutoff) => ({
  type: SET_HARD_CUTOFF,
  hardCutoff
});

export const setCreativeApiError = (error, isError = false) => ({
  type: SET_CREATIVE_API_ERROR,
  error,
  isError
});

export const resetCreativeState = () => ({
  type: RESET_CREATIVE_STATE
});

export const setDynamicTargetingKeys = (keys) => ({
  type: SET_DYNAMIC_TARGETING_KEYS,
  keys
});
